<script lang="ts" setup>
const { clear } = useUserSession()
const logOut = async () => {
  await clear()
  window.location.replace('/')
}

const goTo = (href: string) => window.location.replace(href)
</script>

<template>
  <LayoutContainer
    id="header-container"
    class="backdrop-blur-xl"
    style="background-color: rgba(45 46 55 / 0.3)"
  >
    <div class="flex items-center justify-between h-full">
      <a href="/">
        <ImageComponent
          src="/img/logo-contigo.png"
          alt="Contigo"
          class="h-10 lg:h-14 cursor-pointer"
        />
      </a>

      <AuthState>
        <template #default="{ loggedIn }">
          <template v-if="loggedIn">
            <PvSplitButton
              severity="contrast"
              :model="
                [
                  {
                    label: 'Cerrar sesión',
                    icon: 'icon-[ph--sign-out-bold] ',
                    command: logOut,
                    visible: true,
                  },
                ].filter((item) => item.visible)
              "
              @click="goTo('/user/profile')"
            >
              <div class="flex items-center gap-2">
                <span class="icon-[ph--user-bold] text-2xl" />
                <span class="text-md hidden font-bold uppercase lg:inline">Mi cuenta</span>
              </div>
            </PvSplitButton>
          </template>
          <template v-else>
            <PvButton
              severity="contrast"
              as="a"
              href="/user/login"
              class="p-1 md:p-2"
            >
              <div class="flex items-center gap-2 md:gap-1">
                <span
                  class="icon-[ph--user-bold] md:icon-[ph--user-circle-bold] text-xl md:text-2xl"
                />
                <span class="text-md hidden font-bold uppercase lg:inline">Acceder</span>
              </div>
            </PvButton>
          </template>
        </template>
        <template #placeholder>
          <PvButton
            severity="contrast"
            class="p-1 md:p-2"
          >
            <div class="flex items-center gap-2 md:gap-1">
              <span
                class="icon-[ph--user-bold] md:icon-[ph--user-circle-bold] text-xl md:text-2xl"
              />
              <span class="text-md hidden font-bold uppercase lg:inline">Cargando</span>
            </div>
          </PvButton>
        </template>
      </AuthState>
    </div>
  </LayoutContainer>
</template>
